import { ActivityLogAction } from "src/common/models/activityLog";
import { Languages } from "../types";
import { CommonPagesDescriptions } from "./types";

const DescriptionsEnUs: CommonPagesDescriptions = {
    ACTIVE_STATUS: "Active",
    INACTIVE_STATUS: "Inactive",
    YES: "Yes",
    NO: "No",
    ACTIONS: {
        EDIT: "Edit",
        DELETE: "Delete",
        VIEW: "View",
        CREATE_PAYMENT: "Create Payment",
    },
    FORM: {
        REQUIRED_FIELD: (fieldName: string) => `${fieldName} is required`,
        UNKNOWN_ERROR: "An error ocurred while processing, contact support",
        INVALID_AMOUNT: "Invalid Amount",
        AMOUNT_MUST_BE_GT_ZERO: "Amount must be greater than zero",
        AMOUNT_MUST_BE_GET_ZERO: "Amount must be greater or equal than zero",
    },
    REPORT: {
        EXPORT: "Exportar Datos",
        PRINT: "Imprimir",
    },
    UNAUTHORIZED_PAGE: {
        TITLE: "Unauthorized",
        DESCRIPTION: "No authorization found for this page.",
        ACTION_BUTTON: "Go Home",
    },
    CURRENCY_SYMBOL: "GTQ",
    ACCEPT: "Accept",
    CANCEL: "Cancel",
    SAVE: "Save",
    ACTIVITY_LOG_ACTIONS: {
        [ActivityLogAction.CREATE]: "Record Creation",
        [ActivityLogAction.UPDATE]: "Record Updation",
        [ActivityLogAction.DELETE]: "Record Deletion",
        [ActivityLogAction.ACTIVATED]: "Record Activattion",
        [ActivityLogAction.INACTIVATED]: "Record Inactivation",
    },
}

const DescriptionsEsUs: CommonPagesDescriptions = {
    ACTIVE_STATUS: "Activo",
    INACTIVE_STATUS: "Inactivo",
    YES: "Si",
    NO: "No",
    ACTIONS: {
        EDIT: "Editar",
        DELETE: "Eliminar",
        VIEW: "Ver",
        CREATE_PAYMENT: "Crear Pago",
    },
    FORM: {
        REQUIRED_FIELD: (fieldName: string) => `${fieldName} es requerido`,
        UNKNOWN_ERROR: "Ha ocurrido un error al procesar la petición, contactar a soporte",
        INVALID_AMOUNT: "Monto inválido",
        AMOUNT_MUST_BE_GT_ZERO: "El Monto debe ser mayor a cero",
        AMOUNT_MUST_BE_GET_ZERO: "El Monto debe ser mayor o igual a cero",
    },
    REPORT: {
        EXPORT: "Export Data",
        PRINT: "Print",
    },
    UNAUTHORIZED_PAGE: {
        TITLE: "Error de Autorización",
        DESCRIPTION: "No tienes autorización para esta página.",
        ACTION_BUTTON: "Ir a Inicio",
    },
    CURRENCY_SYMBOL: "GTQ",
    ACCEPT: "Aceptar",
    CANCEL: "Cancelar",
    SAVE: "Guardar",
    ACTIVITY_LOG_ACTIONS: {
        [ActivityLogAction.CREATE]: "Creación de registro",
        [ActivityLogAction.UPDATE]: "Actualización de registro",
        [ActivityLogAction.DELETE]: "Eliminación de registro",
        [ActivityLogAction.ACTIVATED]: "Activación de registro",
        [ActivityLogAction.INACTIVATED]: "Inactivación de registro",
    },
}

const commonPageDictionary = {}
commonPageDictionary[Languages.ENGLISH_US] = DescriptionsEnUs
commonPageDictionary[Languages.SPANISH_US] = DescriptionsEsUs

export const getCommonPagesDescriptions = (systemLang: Languages): CommonPagesDescriptions => (
    commonPageDictionary[systemLang]
)